export enum UpdateDeleteState {
	Default = 0,
	Update = 1,
	Delete = 2
}